export const common = {
  NAME: "portal",
  VERSION: "0.1",
  HTTP_TIMEOUT: 60000,
  BUILD_DATE: `${new Date().toLocaleString("vi-VN", {
    timeZone: "Asia/Ho_Chi_Minh",
  })}`,
  DEFAULT_TIMEZONE: "America/Chicago",
};
